import styled from '@emotion/styled'

import { mediaQueryUp } from '~/utils/grid'

export const Wrapper = styled.div`
  width: 100vw;
  background: ${({ theme }) => theme.colors.gray[20]};
  padding-bottom: 3.5rem;
`

export const Information = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  gap: 1rem;
`

export const Date = styled.span`
  font-weight: ${({ theme }) => theme.text.fontWeight.medium};
  color: ${({ theme }) => theme.colors.orange[500]};
`

export const Title = styled.span`
  font-size: ${({ theme }) => theme.text.fontSize.xxl};
  text-align: center;
`

export const VoucherDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  margin: 0 auto;
  max-width: 50rem;

  ${mediaQueryUp('m')} {
    padding: 2rem;
  }
`

export const PeopleCountTitle = styled.span`
  font-size: ${({ theme }) => theme.text.fontSize.xl};
`

export const Price = styled.span`
  font-size: ${({ theme }) => theme.text.fontSize.xxl};
  font-weight: ${({ theme }) => theme.text.fontWeight.semiBold};
  margin-left: auto;
`

export const PeopleCountWrapper = styled.div`
  display: flex;
  text-align: center;
  align-items: center;
  margin-bottom: 1rem;
`

export const CounterWrapper = styled.div`
  width: 8rem;
  margin-right: 1rem;
`

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 18rem;
  margin-top: 2rem;
`

export const ButtonSection = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
`

export const BackButtonWrapper = styled.div`
  display: flex;
  margin: 2rem 1rem;

  ${mediaQueryUp('m')} {
    margin: 2rem 4rem;
  }
`
